import React from "react";
import { Textarea } from "@plum-xoxo/admin-dsm";
import styled from "styled-components";
const StyledDiv = styled.div`
  width: 344px;
  padding: 12px 0 16px;
  text-align: left;
  margin-bottom: 12px;
`;

const CancelReason = ({ cancelReason, setCancelReasonMessage }) => {
  return (
    <StyledDiv>
      <Textarea
        limit={150}
        label="Reason for Cancellation"
        value={cancelReason}
        onChange={(event) => setCancelReasonMessage(event.target.value)}
        placeholder="Please provide a reason for cancelling the reward"
        rows={6}
      />
    </StyledDiv>
  );
};

export default CancelReason;
